import { TravelRequestsQueryFilter } from 'api/travel-requests-list';
import { ApprovalStatus } from 'model/business-enums';
import { QueryFilter } from 'model/essential-types';

export class TravelRequestsFilter implements QueryFilter, TravelRequestsQueryFilter {
  constructor(public text: string = null, public from: string = null, public to: string = null, public statusValue: ApprovalStatus = null, public includeArchived = false) { }

  canClear() {
    return this.text != null || this.from != null || this.to != null || this.statusValue != null || this.includeArchived === true;
  }

  clear() {
    this.text = this.from = this.to = this.statusValue = null;
    this.includeArchived = false;
  }
}
